import React from 'react';
import './CardReasonSchemeEntryFormTable.styl';
import CardReasonSchemeEntryForm from './CardReasonSchemeEntryForm';

export default class CardReasonSchemeEntryFormTable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(index, entry) {
    const {entries} = this.props;
    this.props.onChange(entries.splice(index, 1, entry));
  }

  render() {
    const {entries} = this.props;

    return (
      <table className="scorecard-reason-table generic-table">
        <thead>
          <tr>
            <th className="score">Score</th>
            <th className="reasons">Reasons</th>
          </tr>
        </thead>
        <tbody>
          {entries &&
            entries.size > 0 &&
            entries.map((entry, index) => (
              <CardReasonSchemeEntryForm
                key={entry.point === null ? 'N/A' : entry.point}
                scoringScheme={this.props.scoringScheme}
                entry={entry}
                onChange={entry => this.onChange(index, entry)}
              />
            ))}
        </tbody>
      </table>
    );
  }
}
